module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-13-6e1837b560f5c088297407471a5fc36a.jpg";